import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.function.name.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import category from '~/store/modules/category';
import { extractCategoryHash, extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import CategorySeo from '~/components/functional/Seo/CategorySeo.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryJsonld from '~/components/functional/JsonLD/CategoryJsonld.vue';
import CategoryCatalog from '~/components/organisms/Category/CategoryCatalog.vue';
import CategoryInformationalContent from '~/components/organisms/Category/CategoryInformationalContent.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
import CommercialRibbon from '~/components/atoms/Global/CommercialRibbon.vue';
import activateOpenFacets from '~/const/openFacet';
export default {
  validate: function validate(_ref) {
    var alias = _ref.params.alias;
    return alias && extractCategoryHash(alias);
  },
  components: {
    MdmBreadcrumb: MdmBreadcrumb,
    CategorySeo: CategorySeo,
    CategoryTcVars: CategoryTcVars,
    CategoryJsonld: CategoryJsonld,
    CategoryCatalog: CategoryCatalog,
    CategoryInformationalContent: CategoryInformationalContent,
    CategoryLoading: CategoryLoading,
    CategoryTemplate: CategoryTemplate,
    Empty: Empty,
    CommercialRibbon: CommercialRibbon,
    RatingJsonLd: RatingJsonLd
  },
  httpHeaders: function httpHeaders(_ref2) {
    var app = _ref2.app;
    return _objectSpread({
      'Cache-Control': 'max-age=0, s-maxage=86400, public'
    }, activateOpenFacets(app.store.$cookies) && app.store.state.searchEngine.isSearchEngine && {
      'mdm-client-type': 'bot',
      Vary: 'mdm-client-type'
    });
  },
  fetch: function fetch(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var alias, query, store, error;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              alias = _ref3.params.alias, query = _ref3.query, store = _ref3.store, error = _ref3.error;
              registerStoreModule(store, 'category/', category);
              registerStoreModule(store, 'pageActions/', pageActions);

              if (!process.server) {
                _context.next = 17;
                break;
              }

              store.commit('pageActions/SET_DEFAULT_FILTERBY', extractCategoryFilterByFromQuery(query));
              store.commit('pageActions/SET_DEFAULT_SORTBY', extractCategorySortByFromQuery(query));
              store.commit('pageActions/SET_DEFAULT_ORDERBY', extractCategoryOrderByFromQuery(query));
              store.commit('pageActions/SET_PREVIOUS_PAGE', extractCategoryPreviousPageFromQuery(query));
              store.commit('pageActions/SET_NEXT_PAGE', extractCategoryNextPageFromQuery(query));
              _context.prev = 9;
              _context.next = 12;
              return store.dispatch('category/fetchContent', {
                alias: alias,
                query: query
              });

            case 12:
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](9);
              error({
                statusCode: 404,
                message: 'Not Found'
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 14]]);
    }))();
  },
  asyncData: function asyncData() {
    return {
      serverFetch: process.server
    };
  },
  data: function data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchCategoryQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'category/description',
    products: 'category/products',
    productsCount: 'category/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  })), {}, {
    categoryQuery: function categoryQuery() {
      return _objectSpread(_objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy)), {}, {
        sort: this.sortBy,
        order: this.orderBy
      });
    },
    selectedFilters: function selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },
    currentPath: function currentPath() {
      return "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, this.description.slug, this.description.hash));
    },
    breadcrumb: function breadcrumb() {
      var _this = this;

      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(function (entry) {
        return {
          label: entry.title,
          url: entry.slug ? "".concat(_this.baseURL).concat(_this.buildCategoryUrl(_this.locale, entry.slug, entry.hash)) : "/".concat(_this.locale.market, "/").concat(_this.locale.language)
        };
      });
    },
    pageTitle: function pageTitle() {
      return this.description.seo.meta_title || this.description.name || '';
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "category";'
      };
      return luxConfig;
    },
    title: function title() {
      return this.description.title || '';
    },
    categoryImage: function categoryImage() {
      return this.products && this.products[0] && this.products[0].images && this.products[0].images[0] ? this.products[0].images[0].src : null;
    },
    isSearchQueryAlgolia: function isSearchQueryAlgolia() {
      return this.$route.query.query;
    },
    hasOpenFacets: function hasOpenFacets() {
      if (this.$store.state.searchEngine.isSearchEngine && activateOpenFacets(this.$cookies)) {
        return !this.description.filters.every(function (filter) {
          var facets = filter.facets;
          var isSeoFacets = !facets.min || !facets.max;
          var hasSelectedOpenFacet = [];
          if (isSeoFacets) hasSelectedOpenFacet = facets.filter(function (facet) {
            return facet.selected && facet.is_open;
          });
          return hasSelectedOpenFacet.length <= 0;
        });
      }

      return false;
    }
  }),
  created: function created() {
    var _this2 = this;

    registerStoreModule(this.$store, 'category/', category, true);
    registerStoreModule(this.$store, 'pageActions/', pageActions, true);

    if (process.client && !this.serverFetch) {
      var _this$$route = this.$route,
          alias = _this$$route.params.alias,
          query = _this$$route.query;
      var args = {
        alias: alias,
        query: query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.resetPagination();
      this.resetFilters();
      this.resetCategory();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchCategory(args).then(function () {
          _this2.loadingProducts = false;

          _this2.createEbRecord();

          _this2.scrollBackToProduct(localStorage.getItem('currentProduct'));

          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.serverFetch) {
      this.fetchProducts();
    }

    this.unwatchCategoryQuery = this.$watch('categoryQuery', /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(oldVal, newVal) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (shallowEqualObjects(oldVal, newVal)) {
                  _context2.next = 6;
                  break;
                }

                _this3.loadingProducts = true;
                _context2.next = 4;
                return _this3.handleWatcher(_this3.fetchCategory, 1);

              case 4:
                _this3.resetPagination();

                _this3.loadingProducts = false;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    this.unwatchNextPage = this.$watch('nextPage', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var predicate;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

              if (predicate) {
                _context3.next = 6;
                break;
              }

              _this3.loadingNextPage = true;
              _context3.next = 5;
              return _this3.handleWatcher(_this3.appendProducts, _this3.nextPage);

            case 5:
              _this3.loadingNextPage = false;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    this.unwatchPreviousPage = this.$watch('previousPage', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var predicate;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              predicate = _this3.nextPage === 1 && _this3.previousPage === 1;

              if (predicate) {
                _context4.next = 6;
                break;
              }

              _this3.loadingPreviousPage = true;
              _context4.next = 5;
              return _this3.handleWatcher(_this3.prependProducts, _this3.previousPage);

            case 5:
              _this3.loadingPreviousPage = false;

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
  },
  beforeDestroy: function beforeDestroy() {
    this.unwatchCategoryQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetCategory: 'category/RESET_CATEGORY'
  })), mapActions({
    fetchCategory: 'category/fetchContent',
    appendProducts: 'category/appendProducts',
    prependProducts: 'category/prependProducts'
  })), {}, {
    createEbRecord: function createEbRecord() {
      if (this.description) {
        var earlybirdsId = this.description.earlybirdsWidgets ? this.description.earlybirdsWidgets.id : null;
        window.ebRecoIds = [earlybirdsId];
      }
    },
    fetchProducts: function fetchProducts() {
      var _this4 = this;

      var args = {
        alias: this.$route.params.alias,
        query: _objectSpread(_objectSpread({}, this.categoryQuery), {}, {
          page: this.nextPage
        }),
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.fetchCategory(args).then(function () {
        _this4.loadingProducts = false;

        _this4.createEbRecord();

        _this4.$root.$emit('reset-tcvars');
      });
    },
    handleWatcher: function handleWatcher(handler, page) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var alias, query, profileId;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                alias = _this5.$route.params.alias;
                query = _objectSpread(_objectSpread({}, _this5.categoryQuery), {}, {
                  page: page
                });

                _this5.$root.$emit('sticky-filters-data', _this5.selectedFilters);

                profileId = _this5.$cookies.get('eb-profile') ? _this5.$cookies.get('eb-profile').split(':')[0] : '';
                _context5.prev = 4;
                _context5.next = 7;
                return handler({
                  alias: alias,
                  query: query,
                  profileId: profileId
                });

              case 7:
                _this5.$router.push({
                  query: pickBy(query, function (e) {
                    return !isNil(e);
                  })
                });

                if (!_this5.isSearchQueryAlgolia) {
                  _this5.$root.$emit('reset-tcvars');
                }

                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](4);

                _this5.$logger.error(_context5.t0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[4, 11]]);
      }))();
    },
    scrollBackToProduct: function scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(function () {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }
  }),
  head: function head() {
    return {
      script: [this.speedcurveConfig]
    };
  }
};